import React, { useState } from "react";
import PropTypes from "prop-types";

import RadioFilterOption from "./RadioFilterOption";
import DateFilter from "./DateFilter";

const RadioFilter = ({
  values,
  label,
  name,
  options,
  expandable,
  expandableLimit,
  expandableMoreText,
  expandableLessText,
  highlighted,
}) => {
  const [expanded, setExpanded] = useState(false);

  const fmlDunnoLength = options.length;
  const processedOptions = expanded
    ? options
    : options.slice(0, expandableLimit);

  const showCustomDate =
    name === "date_ranges" && values.date_ranges === "custom";

  return (
    <fieldset className={`radio-filter${highlighted ? " is-highlighted" : ""}`}>
      <h4 className="radio-filter__title">{label}</h4>
      <div className="radio-filter__options">
        {processedOptions.map((option) => (
          <RadioFilterOption name={name} option={option} key={option.key} />
        ))}
      </div>
      <DateFilter label="Ik zoek naar" values={values} show={showCustomDate} />
      {expandable && fmlDunnoLength > expandableLimit && (
        <button
          className="radio-filter__expand"
          onClick={() => setExpanded(!expanded)}
          type="button"
        >
          {expanded ? expandableLessText : expandableMoreText}
        </button>
      )}
    </fieldset>
  );
};

RadioFilter.propTypes = {
  values: PropTypes.shape({}),
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
    })
  ).isRequired,
  expandable: PropTypes.bool,
  expandableLimit: PropTypes.number,
  expandableMoreText: PropTypes.string,
  expandableLessText: PropTypes.string,
  highlighted: PropTypes.bool,
};

RadioFilter.defaultProps = {
  values: {},
  expandable: false,
  expandableLimit: Infinity,
  expandableMoreText: "",
  expandableLessText: "",
  highlighted: false,
};

export default RadioFilter;
